import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=043f9d43&scoped=true"
import script from "./Image.vue?vue&type=script&lang=ts"
export * from "./Image.vue?vue&type=script&lang=ts"
import style0 from "./Image.vue?vue&type=style&index=0&id=043f9d43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043f9d43",
  null
  
)

/* custom blocks */
import block0 from "./Image.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports